import template from './urlEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onDialogUrlEdit(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                icon: _params.icon || 'link',
                title: _params.title,
                fieldTitle: _params.fieldTitle || 'URL',
                content: _params.content
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (content) {
              if (ctrl.onFinished) {
                ctrl.onFinished({ result: { id: _params.id, content: content } });
              }
            });

          function dialogController($mdDialog, icon, title, fieldTitle, content) {
            this.icon = icon;
            this.title = title;
            this.fieldTitle = fieldTitle;
            this.content = content;
            this.confirm = function () {
              $mdDialog.hide(this.content);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
